import OrderDetailsV2 from '@/modules-v2/indent/views/document/index';
import OrderDetailsV3 from '@/modules-v2/indent/views/document-v2/index';
import DocumentListing from '@/components/modules/order/DocumentListing';
import AuditListing from '@/components/modules/order/AuditListing';
import ExceptionView from '@/components/modules/order/exception';
import FreightApproval from '@/modules-v2/indent/views/document/freight-approval';

const order = [
  {
    path: '/indents/outbound',
    name: 'OutboundIndents',
    component: () => import(/* webpackChunkName: "OutboundIndents" */ '@/components/modules/order/OutboundIndents'), // OutboundIndents,
    meta: {
      title: 'Outbound',
      requiresAuth: true,

    },
  },
  {
    path: '/indents/v2/outbound',
    name: 'OutboundIndentsV2',
    component: () => import(/* webpackChunkName: "OutboundIndents" */ '@/components/modules/order/DataView'), // OutboundIndentsV2,
    meta: {
      title: 'Outbound',
      requiresAuth: true,

    },
  },
  {
    path: '/indents/inbound',
    name: 'InboundIndents',
    component: () => import(/* webpackChunkName: "InboundIndents" */ '@/components/modules/order/InboundIndents'), // InboundIndents,
    meta: {
      title: 'Inbound',
      requiresAuth: true,
    },
  },
  {
    path: '/indents/v2/inbound',
    name: 'OutboundIndentsV2',
    component: () => import(/* webpackChunkName: "InboundIndents" */ '@/components/modules/order/DataView'), // InboundIndents,
    meta: {
      title: 'Inbound',
      requiresAuth: true,
    },
    props: {
      isIndentInbound: true,
    },
  },
  {
    path: '/indents',
    redirect: { name: 'OutboundIndents' },
  },
  {
    path: '/exception',
    name: 'Exception',
    component: ExceptionView,
    meta: {
      title: 'Exception',
      requiresAuth: true,
    },
  },
  {
    path: '/indents/documents',
    name: 'DocumentListing',
    component: DocumentListing,
    meta: {
      title: 'Documents',
      requiresAuth: true,
    },
  },
  {
    path: '/indents/freight-approval/:orderId',
    name: 'FreightApproval',
    component: FreightApproval,
    meta: {
      title: 'FreightApproval',
      requiresAuth: true,
    },
  },
  {
    path: '/indents/:orderId/details/:category',
    name: 'OrderDetails',
    component: OrderDetailsV2,
    props: true,
    meta: {
      title: 'Indents',
      requiresAuth: true,
    },
  },
  {
    path: '/indents/:orderId/reindent',
    name: 'reindentOrder',
    component: import(/* webpackChunkName: "OrderForm" */ '@/modules-v2/indent/views/create-update/index'), // OrderForm,
    meta: {
      title: 'Re Indent',
      requiresAuth: true,
    },
  },
  {
    path: '/indents/packing_audit',
    name: 'PackingAudit',
    component: AuditListing,
    meta: {
      title: 'Packing Audit',
      requiresAuth: true,
    },
  },
  {
    path: '/indents/:orderId/detailsV2/:category',
    name: 'OrderDetailsV2',
    component: OrderDetailsV3,
    props: true,
    meta: {
      title: 'Indents',
      requiresAuth: true,
    },
  },
];

export default order;
